// Document ID ranges and gaps by folder (more memory efficient)
// Based on actual files after deduplication

interface DocumentRange {
  start: number;
  end: number;
  gaps?: number[]; // Array of missing IDs within the range
}

export const DOCUMENT_RANGES_BY_FOLDER: Record<string, DocumentRange[]> = {
  '001': [
    { start: 10477, end: 12474 }  // 1998 files, 2 gaps total
  ],
  '002': [
    { start: 12477, end: 13488 },
    { start: 13501, end: 14464 }  // 1988 files, 12 gaps (013489-013500)
  ],
  '003': [
    { start: 14477, end: 16476 }  // 2000 files, 0 gaps
  ],
  '004': [
    { start: 16477, end: 18463 }  // 1987 files, 13 gaps total
  ],
  '005': [
    { start: 18477, end: 20289 }  // 1813 files, 100 gaps total
  ],
  '006': [
    { start: 20477, end: 22468 }  // 1992 files, 8 gaps total
  ],
  '007': [
    { start: 22477, end: 24410 }  // 1934 files, 66 gaps total
  ],
  '008': [
    { start: 24477, end: 26449 }  // 1973 files, 27 gaps total
  ],
  '009': [
    { start: 26477, end: 28474 }  // 1998 files, 2 gaps total
  ],
  '010': [
    { start: 28477, end: 30422 }  // 1946 files, 54 gaps total
  ],
  '011': [
    { start: 30477, end: 32437 }  // 1961 files, 39 gaps total
  ],
  '012': [
    { start: 32477, end: 33593 }  // 1117 files, 7 gaps total
  ]
};

// Generate document IDs for a folder
export const generateDocumentIds = (folder: string): string[] => {
  const ranges = DOCUMENT_RANGES_BY_FOLDER[folder];
  if (!ranges) return [];
  
  const ids: string[] = [];
  
  for (const range of ranges) {
    for (let id = range.start; id <= range.end; id++) {
      // Skip gaps if specified
      if (range.gaps && range.gaps.includes(id)) {
        continue;
      }
      ids.push(id.toString().padStart(6, '0'));
    }
  }
  
  return ids;
};

// Get document count for a folder
export const getDocumentCount = (folder: string): number => {
  return generateDocumentIds(folder).length;
};